import moment from 'moment-timezone';

export const isActBetween0And7 = ({ date, start }): boolean => {
  const lowerBound = moment(date).set('hour', 0).valueOf();
  const upperBound = moment(date).set('hour', 7).valueOf();
  const granularity = undefined;

  return moment(start).isBetween(lowerBound, upperBound, granularity, '[)');
};
